export type DeliveryDaysCount = { earliest: number; latest: number }

export type DeliveryDaysCountWithAmount = DeliveryDaysCount & { amount: string }

export function getDeliveryDaysCount(
  earliestDate: Date,
  latestDate: Date,
  now: Date = new Date(),
): DeliveryDaysCount {
  const nowUTC = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
  )
  const msPerDay = 1000 * 60 * 60 * 24

  const earliest = Math.round(
    (Date.UTC(
      earliestDate.getUTCFullYear(),
      earliestDate.getUTCMonth(),
      earliestDate.getUTCDate(),
    ) -
      nowUTC) /
      msPerDay,
  )
  const latest = Math.round(
    (Date.UTC(
      latestDate.getUTCFullYear(),
      latestDate.getUTCMonth(),
      latestDate.getUTCDate(),
    ) -
      nowUTC) /
      msPerDay,
  )

  return { earliest, latest }
}
